export const requiredValidator = (value) =>
  value ? "" : "Error: This field is required.";
export const checkboxValidator = (value) =>
  !value ? "Terms & Conditions checkbox is required" : "";
